module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/559ff3f97ba4e20648b7846943d9fe33.png";